import { render } from "./CropFieldInfo.vue?vue&type=template&id=a44bc690"
import script from "./CropFieldInfo.vue?vue&type=script&lang=js"
export * from "./CropFieldInfo.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/crop_field.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fquality_control%2Fcrop_field%2FCropFieldInfo.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__